// @flow
import React from 'react';
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Strong } from '@finect/tabular-core/Strong';
import { X } from '@finect/tabular-icons/x';

export const FormContent = styled.div`
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.terciaryL};

  ${minMediaQueries.phone`
    padding: 28px 34px;
  `};
`;

export const FormTitle = styled(Strong)`
  ${getFont(0)}
`;

export const FormFields = styled.div`
  margin-top: 10px;
  ${getFont('-1', 'compact')}

  ${minMediaQueries.phablet`
    margin-top: 15px;
    padding: 0 40px;
  `};

  ${minMediaQueries.miniDesktop`
    margin-top: 15px;
    padding: 0 150px;
  `};
`;

export const FormField = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: column;
  padding: 5px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.uiM};

  &:last-child {
    border: none;
  }

  ${minMediaQueries.phone`
    flex-direction: row;
    align-items: center;
    min-height: 50px;
  `};
`;

export const FormFieldDescription = styled.div`
  min-width: 240px;
  max-width: 240px;
  padding-right: 40px;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.terciary};
`;

export const FormFieldValueContent = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 500px;
  padding-top: 5px;

  ${minMediaQueries.phone`
    align-items: center;
    margin-top: 0;
  `};
`;

export const FormFieldValue = styled.div`
  margin-right: 4px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.terciaryDD};
`;

export const FormFieldValueHelp = styled.div`
  color: ${({ theme }) => theme.colors.terciaryM};
`;

export const StyledClose = styled.span`
  position: relative;
  right: 10px;
  float: right;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.terciaryM};
`;

export const CloseForm = ({ onClick }: { onClick: Function }) => (
  <StyledClose onClick={onClick}>
    <X />
  </StyledClose>
);
